<template>
  <div v-if='newUser'>
    <EntryPage/>
  </div>
  <div v-else-if="admin && !contestantId">
    <QuizMasterPage/>
  </div>
  <div v-else>
    <PlayerPage/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EntryPage from '@/components/EntryPage';
import PlayerPage from "@/components/PlayerPage";
import QuizMasterPage from "@/components/QuizMasterPage";

export default {
    name: 'QuizPage',
    components: {
      QuizMasterPage,
      PlayerPage,
      EntryPage
    },
    computed: mapGetters(['newUser', 'admin', 'contestantId']),
}
</script>
